import axios from "../api";
import { objectToParam } from "../../libs/utils";

export async function getTransportVouchers(params = {}) {
  const parameters = objectToParam(params);
  const { data } = await axios.get("transport-voucher-templates?" + parameters);
  return data;
}

export async function getTransportVoucher(id) {
  const { data } = await axios.get("transport-voucher-templates/" + id);
  return data;
}

export async function createTransportVoucher(values) {
  const { data } = await axios.post("transport-voucher-templates", values);
  return data;
}

export async function sendTransportVoucher(
  registrationsId,
  transportRequestId
) {
  const { data } = await axios.post(
    `registrations/${registrationsId}/transport-requests/${transportRequestId}/send-voucher`
  );
  return data;
}

export async function updateTransportVoucher(id, values) {
  const { data } = await axios.put("transport-voucher-templates/" + id, values);
  return data;
}

export async function deleteTransportVoucher(id) {
  const { data } = await axios.delete("transport-voucher-templates/" + id);
  return data;
}
